import type { CockpitRelation } from '@internal/spassu-code-contract';
import type { CockpitNodeKind } from '../model/cockpitViewModel';

export interface CockpitSelection {
  kind: CockpitNodeKind;
  id: string;
  revision: number | null;
}

export interface CockpitSelectionState {
  selected: CockpitSelection | null;
  relatedIds: string[];
}

export type CockpitSelectionAction =
  | {
      type: 'select';
      selection: CockpitSelection;
      relations: CockpitRelation[];
    }
  | { type: 'clear' };

export const EMPTY_COCKPIT_SELECTION: CockpitSelectionState = {
  selected: null,
  relatedIds: [],
};

export function cockpitSelectionReducer(
  state: CockpitSelectionState,
  action: CockpitSelectionAction,
): CockpitSelectionState {
  if (action.type === 'clear') return EMPTY_COCKPIT_SELECTION;
  if (sameSelection(state.selected, action.selection)) {
    return EMPTY_COCKPIT_SELECTION;
  }
  return {
    selected: action.selection,
    relatedIds: relatedNodeIds(action.selection.id, action.relations),
  };
}

export function relatedNodeIds(
  selectedId: string,
  relations: CockpitRelation[],
): string[] {
  const ids = new Set<string>([selectedId]);
  for (const relation of relations) {
    if (relation.from.id === selectedId) ids.add(relation.to.id);
    if (relation.to.id === selectedId) ids.add(relation.from.id);
  }
  return [...ids].sort();
}

function sameSelection(
  current: CockpitSelection | null,
  next: CockpitSelection,
): boolean {
  return Boolean(
    current &&
      current.id === next.id &&
      current.kind === next.kind &&
      current.revision === next.revision,
  );
}
